/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterContentInit,
  ChangeDetectorRef,
  ContentChild,
  Directive,
  inject,
  input,
} from '@angular/core';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { AbstractFormField } from '../../models/abstract-form-field/abstract-form-field.model';
import { FormField } from '../../models/form-field/form-field.interface';

@Directive({
  selector: '[appFormField]',
  standalone: true,
})
export class FormFieldDirective<T> implements AfterContentInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly formFieldComponent = inject(AbstractFormField);

  readonly appFormField = input<FormField>();

  @ContentChild(BaseFormControlComponent)
  formControlComponent!: BaseFormControlComponent<T>;

  ngAfterContentInit(): void {
    this.setFormControlComponentProperties();
  }

  private setFormControlComponentProperties(): void {
    const appFormField = this.appFormField();
    if (!appFormField || !this.formControlComponent) {
      return;
    }

    const target: any =
      'label' in this.formControlComponent
        ? this.formControlComponent
        : this.formFieldComponent;

    // Set form field label
    if (target.label) {
      target.label.set(appFormField.fieldLabel);
    }

    // Set form field placeholder
    if (appFormField.fieldPlaceholder) {
      const formControlComponent: any = this.formControlComponent;
      formControlComponent.placeholder.set(appFormField.fieldPlaceholder);
    }

    this.changeDetectorRef.detectChanges();
    this.formControlComponent.detectChanges();
  }
}
